import { RavenInputField, RavenModal } from "@ravenpay/raven-bank-ui";
import React from "react";
import "../modals/styles/WithdrawalModal.css";

interface MyComponentProps {
  visible: boolean;
  onClose: () => void;
}

const WithdrawalModal: React.FC<MyComponentProps> = ({ visible, onClose }) => {
  const copyIcon = (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="img"
    >
      <path
        d="M6.25 2.5H12.1667C14.0335 2.5 14.9669 2.5 15.68 2.86331C16.3072 3.18289 16.8171 3.69282 17.1367 4.32003C17.5 5.03307 17.5 5.96649 17.5 7.83333V13.75M5.16667 17.5H11.9167C12.8501 17.5 13.3168 17.5 13.6733 17.3183C13.9869 17.1586 14.2419 16.9036 14.4017 16.59C14.5833 16.2335 14.5833 15.7668 14.5833 14.8333V8.08333C14.5833 7.14991 14.5833 6.6832 14.4017 6.32668C14.2419 6.01308 13.9869 5.75811 13.6733 5.59832C13.3168 5.41667 12.8501 5.41667 11.9167 5.41667H5.16667C4.23325 5.41667 3.76654 5.41667 3.41002 5.59832C3.09641 5.75811 2.84144 6.01308 2.68166 6.32668C2.5 6.6832 2.5 7.14991 2.5 8.08333V14.8333C2.5 15.7668 2.5 16.2335 2.68166 16.59C2.84144 16.9036 3.09641 17.1586 3.41002 17.3183C3.76654 17.5 4.23325 17.5 5.16667 17.5Z"
        stroke="#8B8B8B"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );

  const [details, setDetails] = React.useState({
    amount: ""
  });

  const handleChange = (e: any) => {
    const { name, value } = e.target;
    const obj = { ...details, [name]: value };
    setDetails(obj);
  };

  return (
    <>
      <RavenModal
        btnLabel="Make Withdrawal"
        btnColor="deep-green-light"
        onBtnClick={() => {}}
        visble={visible}
        onClose={onClose}
        disabled={!details?.amount}
      >
        <div className="withdrawal-bankbox-modal-wrap">
          {/* title text box start */}
          <div className="title-text-box">
            <p className="title">Withdraw to Bank</p>
            <p className="text">Withdraw form Bankbox Balance</p>
          </div>
          {/* title text box end */}

          {/* form start */}
          <form
            onSubmit={(e) => {
              e.preventDefault();
            }}
            style={{ width: "100%" }}
            action=""
            autoComplete="off"
          >
            <RavenInputField
              color="deep-green-light"
              label="Amount to Withdraw * "
              placeholder="Enter your Amount"
              type="number"
              numberPrefix={"₦"}
              value={details?.amount}
              name="amount"
              onChange={handleChange}
              thousandFormat
            />
          </form>
          {/* form end */}
          {/* current balance box start */}
          <div className="current-balance-box">
            <p className="text">Current Balance</p>
            <p className="amount">₦240,000.03</p>

            {/* copy text box start */}
            <div className="copy-text-box">
              <div className="copy-box">
                <figure className="img-box">{copyIcon}</figure>
              </div>
              <div className="copy-text">21358776118 • Raven</div>
            </div>
            {/* copy text box end */}
          </div>
          {/* current balance box end */}
        </div>
      </RavenModal>
    </>
  );
};

export default WithdrawalModal;
